import {Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import {Utils} from "../../../../core/helpers/Utils";

@Component({
    selector: 'app-expandable-row',
    templateUrl: './expandable-row.component.html',
    styleUrls: ['./expandable-row.component.scss'],
    standalone: false
})
export class ExpandableRowComponent {
    isExpanded = false;
	@Input() isResourcesTable!: boolean;
	@Input() expandContent: TemplateRef<any>;
	@Input() cellsContent: TemplateRef<any>;
	@Input() isSelected = false;
	@Input() clickable = false;
	@Input() row: any;
	@Output() rowClick: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild('template') template: TemplateRef<any>;

	currentHoverItem: ResourceModel | null;
	utils = Utils;


	constructor() {}

	toggleRow() {
	    this.isExpanded = !this.isExpanded;
	}

	onHoverRow(row: any) {
	    this.currentHoverItem = row;
	}

	onClick(row: any) {
	    this.rowClick.emit(row);
	}
}
